<template>
  <div>
    <el-cascader
      v-model="region"
      :options="options"
      :props="{ expandTrigger: 'hover', value: 'id', label: 'name', children: 'childs', checkStrictly: checkStrictly }"
      @change="handleChange"
      ref="myCascader"
      v-bind="$attrs"
      :style="{ width: width ? `${width}px` : '100%' }"
      clearable
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import regionData from '@/json/region'

export default {
  props: {
    regionId: {
      type: Array,
      default: () => []
    },
    width: {
      type: [String, Number],
      default: ''
    },
    checkStrictly: { // 是否允许父子不关联
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: regionData,
      region: []
    }
  },
  watch: {
    regionId: {
      handler(val) {
        this.region = val
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    ...mapState({
      regionList: (state) => state.app.regionList
    })
  },
  methods: {
    handleChange(e) {
      console.log('地区数据 :>> ', e)
      if(!e.length || this.checkStrictly) return this.$emit('update:regionId', e)

      const district = this.$refs.myCascader.getCheckedNodes()[0].label
      const city = this.$refs.myCascader.getCheckedNodes()[0].parent.label
      const province = this.$refs.myCascader.getCheckedNodes()[0].parent.parent.label

      this.$emit('update:regionLabel', [province, city, district])
      this.$emit('update:regionId', e)
      if (city.indexOf('市辖') !== -1) {
        this.$emit('update:region', city)
        return
      }
      this.$emit('update:region', province)
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped></style>
